import React, {useEffect, useState} from 'react';
import {Box, Chip, IconButton, Stack} from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import ReplayIcon from '@mui/icons-material/Replay';
import MailPill from './MailPill';
import GhostMailPill from "./GhostMailPill";

const EmailManager = () => {
        const [expandedPill, setExpandedPill] = useState(null);
        const [responses, setResponses] = useState({});
        const [sortConfig, setSortConfig] = useState({field: null, direction: 'asc'});
        const [pills, setPills] = useState([]);
        const [loading, setLoading] = useState(true);

        const fetchData = async () => {
            setLoading(true);

            try {
                // Make a GET request to the backend
                const response = await fetch(process.env.REACT_APP_BASE_URL + '/data');

                if (!response.ok) {
                    throw new Error('Failed to fetch data from the backend');
                }

                const data = await response.json();

                // Filter function to clean up the response data
                const filterValue = (value) => {
                    if (value === null || value === undefined || value === '#' || value === '0') return 'N/A';
                    if (typeof value === 'string' && value.trim() === '') return 'N/A';
                    if (typeof value === 'number' && value === 0) return 'N/A';
                    if (Array.isArray(value) && value.length === 0) return 'N/A';
                    return value;
                };
                // Transform data according to the provided structure
                data.map((item) => (
                    console.log(item)
                ))

                const transformedData = data.map((item) => ({
                    id: filterValue(item.id),
                    date: filterValue(item.date),
                    summary: filterValue(item.fname),
                    intent: filterValue(item.intent),
                    sentiment: filterValue(item.sentiment),
                    name: `${filterValue(item.lname)} ${filterValue(item.summary)}`,
                    done: filterValue(item.status),
                    originalEmail: filterValue(item.email),
                    address: `${filterValue(item.meter_number)}, ${filterValue(item.phone_number)} ${filterValue(item.contract_number)}`,
                    meter_number: filterValue(item.postal_code),
                    contract_number: `${filterValue(item.street_address)} ${filterValue(item.other_contract_numbers)}`,
                    phone_number: filterValue(item.is_corporate),
                    is_corporate: filterValue(item.company_name),
                    company_name: filterValue(item.status),
                }));

                console.log(transformedData);

            setPills(transformedData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const deleteTicket = async (id) => {
        try {
            const response = await fetch(process.env.REACT_APP_BASE_URL + `/data`, {
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({id: id}),
            });

                if (!response.ok) {
                    throw new Error('Failed to delete ticket');
                }

                // Use filter to remove the pill with the matching id
                setPills((prevPills) => prevPills.filter((pill) => pill.id !== id));
            } catch (error) {
                console.error('Error deleting ticket:', error.message);
            }
        };


        useEffect(() => {
            fetchData();
        }, []);

        const toggleExpandedPill = (id) => {
            setExpandedPill(expandedPill === id ? null : id);
        };

        const handleResponseChange = (id, value) => {
            setResponses((prev) => ({...prev, [id]: value}));
        };

    const toggleDoneStatus = async (id) => {
        const response = await fetch(process.env.REACT_APP_BASE_URL + '/data', {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: id}),
        });

            if (!response.ok) throw new Error('Failed to update status for pill: ' + id);
            else {
                setPills((prevPills) =>
                    prevPills.map((pill) =>
                        pill.id === id ? {...pill, done: !pill.done} : pill
                    )
                );
            }

        };

        const spinStyle = {
            animation: 'spin 1s linear infinite',
            '@keyframes spin': {
                from: {transform: 'rotate(360deg)'},
                to: {transform: 'rotate(0deg)'},
            },
        };

        const sortPills = (field) => {
            setExpandedPill(null);

            const direction =
                sortConfig.field === field && sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const sortedPills = [...pills].sort((a, b) => {
                if (a[field] < b[field]) return direction === 'asc' ? -1 : 1;
                if (a[field] > b[field]) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            setPills(sortedPills);
            setSortConfig({field, direction});
        };

        const getSortIcon = (field) => {
            if (sortConfig.field === field) {
                return sortConfig.direction === 'asc' ? <NorthIcon sx={{fontSize: 15}}/> : <SouthIcon sx={{fontSize: 15}}/>;
            }
            return null;
        };


        return (
            <Box sx={{width: '100%'}}>
                <Box
                    sx={{
                        position: 'sticky',
                        top: '64px',
                        zIndex: 2,
                        borderBottom: '1px solid lightgray',
                        p: 2,
                        backdropFilter: 'blur(60px)',
                    }}
                >
                    <Stack direction="row" spacing={1} justifyContent="space-between">
                        {[
                            ['date', 'Date', 120],
                            ['summary', 'Summary', 500],
                            ['intent', 'Intent', 140],
                            ['sentiment', 'Sentiment', 140],
                            ['name', 'Name', 140],
                            ['done', 'Status', 110],
                        ].map(([field, label, width]) => (
                            <Chip
                                key={field}
                                label={label}
                                onClick={() => sortPills(field)}
                                icon={getSortIcon(field)}
                                sx={{
                                    fontSize: '0.875rem',
                                    padding: '4px 8px',
                                    width,
                                    cursor: 'pointer',
                                    fontWeight: getSortIcon(field) ? 'bold' : 'normal',
                                }}
                            />
                        ))}
                        <IconButton onClick={() => fetchData()} sx={loading ? spinStyle : {}}>
                            <ReplayIcon/>
                        </IconButton>
                    </Stack>
                </Box>
                <Box sx={{overflowY: 'auto', mt: 1, width: '100%'}}>
                    {loading ? (
                        [1, 2, 3, 4, 5].map((pill) => (
                            <GhostMailPill/>
                        ))
                    ) : (
                        pills.map((pill) => (
                            <MailPill
                                key={pill.id}
                                pill={pill}
                                expanded={expandedPill === pill.id}
                                toggleExpanded={toggleExpandedPill}
                                responses={responses}
                                handleResponseChange={handleResponseChange}
                                toggleDoneStatus={toggleDoneStatus}
                                deleteTicket={deleteTicket}
                            />
                        ))
                    )}
                </Box>
            </Box>
        );
    }
;

export default EmailManager;
